import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import MarketCanvas from "@/components/MarketCanvas";
import { Reveal, MaskReveal } from "@/components/Reveal";

const FinalCTA = () => (
  <section data-testid="final-cta" className="relative overflow-hidden bg-ivory py-32 lg:py-44">
    <div className="absolute inset-0 opacity-60" aria-hidden="true">
      <MarketCanvas />
    </div>
    <div className="relative container-x text-center max-w-3xl mx-auto">
      <Reveal>
        <p className="eyebrow">T Plus One</p>
      </Reveal>
      <MaskReveal
        as="h2"
        lines={["Markets move every day.", "Understanding them takes time."]}
        className="mt-6 text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.08]"
        lineClass=""
      />
      <Reveal delay={0.3}>
        <p className="mt-6 text-lg text-dim">Start building your understanding with T Plus One.</p>
      </Reveal>
      <Reveal delay={0.4}>
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <motion.div whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
            <Link
              to="/courses"
              data-testid="final-cta-courses"
              className="group inline-flex items-center gap-2 rounded-full bg-ink text-ivory px-8 py-4 text-sm font-medium transition-colors hover:bg-pine"
            >
              Explore Courses <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-0.5" />
            </Link>
          </motion.div>
          <Link
            to="/entrade"
            data-testid="final-cta-entrade"
            className="link-arrow inline-flex items-center gap-2 rounded-full border border-ink/20 px-8 py-4 text-sm font-medium transition-colors hover:border-pine hover:text-pine"
          >
            Join EnTrade <ArrowRight size={15} className="arrow" />
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);

export default FinalCTA;
